import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useQueryParams = () => {
  const location = useLocation();
  const [queryParams, setQueryParams] = useState({});

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    
    for (const [key, value] of searchParams.entries()) {
      // Convert 'true'/'false' strings to booleans
      if (value === 'true') {
        params[key] = true;
      } else if (value === 'false') {
        params[key] = false;
      } else {
        params[key] = value;
      }
    }
    
    setQueryParams(params);
  }, [location.search]);

  const getParam = (key, defaultValue = null) => {
    return queryParams[key] !== undefined ? queryParams[key] : defaultValue;
  };

  return {
    queryParams,
    getParam,
    createCallSession: getParam('createCallSession', false)
  };
};
